"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _reactErrorBoundary = require("react-error-boundary");
/** @todo add to core */
const ErrorBoundary = exports.ErrorBoundary = function ErrorBoundary(children) {
  let {
    onError,
    FallbackComponent
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _reactErrorBoundary.withErrorBoundary)(children, {
    FallbackComponent: FallbackComponent !== null && FallbackComponent !== void 0 ? FallbackComponent : () => null,
    // eslint-disable-next-line no-console
    onError: onError !== null && onError !== void 0 ? onError : (err, info) => console.error(err, info)
  });
};